module.exports = __webpack_public_path__ + "assets/img/Kathleen_Barrett_MSN-APRN-BC.28ff11f8.jpg";